import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

import { Typography } from '@vivaahealth/design-system';
import { api } from 'common';

import { StyledBorder, StyledHeaderSmall } from '../Common';

interface Props {
  publications?: api.ProviderProfile.Publication[];
  publicationsRef?: React.RefObject<HTMLDivElement>;
}

const Publications: React.FC<Props> = ({ publications, publicationsRef }) => {
  const embedded = useSelector((store: store.All) => store.embedded);

  if (!publications || publications.length < 1) {
    return null;
  }

  const content = (
    <>
      <StyledHeaderSmall variant="headline-small" bold>
        Publications
      </StyledHeaderSmall>
      {publications.map((p, i) => (
        <Typography
          variant="paragraph-large"
          key={`${p.publication}${i}`}
          className="mb-3"
        >
          {p.publication} <br />
          {p.publisher ? `${p.publisher}` : ''}
          {p.year ? `, ${p.year}` : ''}
        </Typography>
      ))}
    </>
  );
  return (
    <>
      <StyledBorder />
      {embedded ? (
        <div ref={publicationsRef}>{content}</div>
      ) : (
        <div ref={publicationsRef}>{content}</div>
      )}
    </>
  );
};

export default Publications;
